import {CurrentBloggerFormFields} from "../types/blogger-card.types";

export const bloggerProfileModalName = 'blogger-profile';

export const currentBloggerSelectFormFields: Array<CurrentBloggerFormFields> = [
  {
    fieldName: 'loyaltyType',
    label: 'Лояльность блогера'
  }
]

export const fieldsToReset = ['bloggerContact', 'bankDetails'];
